import {PageCollection} from '@simpli/resource-collection'
import {HttpExclude, Request} from '@simpli/serialized-request'
import {GithubOrganizationSocialType} from '@/model/resource/GithubOrganizationSocialType'
import {RequestExpose} from '@simpli/serialized-request'

@HttpExclude()
export class GithubOrganizationSocialTypeCollection extends PageCollection<
  GithubOrganizationSocialType
> {
  constructor() {
    super(GithubOrganizationSocialType)
  }

  resource?: IGithubOrganizationSocialTypeCollectionResourcesHolder

  @RequestExpose() idOrganizationFk: number | null = null

  queryAsPage() {
    return this.listGithubOrganizationSocialType()
  }

  async listGithubOrganizationSocialType() {
    const response = await Request.get(
      `/client/github-organization-social-type`,
      {
        params: this.params,
      }
    )
      .name('listGithubOrganizationSocialType')
      .as(this)
      .getResponse()

    return response
  }
}

export interface IGithubOrganizationSocialTypeCollectionResourcesHolder {}
